import { render, staticRenderFns } from "./responsiveamazingOffers.vue?vue&type=template&id=f2a4a4c0&scoped=true&"
import script from "./responsiveamazingOffers.vue?vue&type=script&lang=js&"
export * from "./responsiveamazingOffers.vue?vue&type=script&lang=js&"
import style0 from "./responsiveamazingOffers.vue?vue&type=style&index=0&id=f2a4a4c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a4a4c0",
  null
  
)

export default component.exports